module.exports = __webpack_public_path__ + "static/img/en.208c58e1.png";